import React ,{ useState,useEffect}from 'react';
import webapi from '../../../api/webapi';
import SearchBodySearchBox from './SearchBodySearchBox';
import SearchBodySearchResult from './SearchBodySearchResult';
import Loading from '../modal/Loading';
import EmptyDiv from '../Footer/EmptyDIV';


//import { ThemeProvider } from 'react-bootstrap';


const SearchBody = (props) => {
    const [statments,setStatments] = useState(undefined);
    const [pageData,setPageData] = useState('');
    const [loadingShow,setLoadingShow] = useState(false);
    const [results,setResults] = useState([]);
    const [t_results,setT_results] = useState([]);
    const [searchtabIndex,setSearchtabIndex] = useState(0);
    //const [selectedBookGroup,setSelectedBookGroup] = useState(0);
    const [selectedBookGroup,setSelectedBookGroup] = useState(undefined);
    const [selectedBook,setSelectedBook] = useState(undefined);
    const [selectedChapter,setSelectedChapter] = useState('All');

    const [word,setWord] = useState('');

    //state = { languageInfo: [{Code:"fa",Title:"فارسی",Direction:"rtl"}] }
    //state = {loadingShow : false}

    useEffect(()=>{
        //setState({ SearchtabIndex : 0})
        async function fetchData() {
            
            if (props.languageInfo)
            {
                const pageList = await webapi.get('pages/datapages/202/'+props.languageInfo[0].Code);
                //console.log(pageList);
                setPageData(pageList.data);
            }else{
                const pageList = await webapi.get('pages/datapages/202/fa');
                //console.log(pageList);
                setPageData(pageList.data);
            }
        }

        fetchData();
        
        //fetch('https://api.ipify.org/?format=json')
        // fetch('https://geolocation-db.com/json/')
        //     .then(response => {
        //         return response.json();
        //     }, "jsonp")
        //     .then(res => {
        //         //setLog('pages/log/Search/visit/'+res.ip.replaceAll('.',','))
        //         setLog('pages/log/Search/visit/'+res.IPv4.replaceAll('.',','))
        //     })
        //     .catch(err => setLog('pages/log/Search/visit/'+err));
    },[props])

    // const async setLog(Data) {
    //     await webapi.post(Data);
    // }

    

    // strEncodeUTF16(str){
    //     var buf = new ArrayBuffer(str.length*4);
    //     var bufView = new Uint32Array(buf);
    //     for (var i=0, strLen=str.length; i < strLen; i++) {
    //       bufView[i] = str.charCodeAt(i);
    //     }
    //     return bufView;
    //   }

    //   getUTF32LEUrl(str) {
    //     // The UTF-32LE BOM
    //     const BOM = new Uint8Array([0xFF,0xFE,0x00,0x00]);
    //     // A byte array and DataView to use when converting 32-bit LE to bytes;
    //     // they share an underlying buffer
    //     const uint8 = new Uint8Array(4);
    //     const view = new DataView(uint8.buffer);
    //     // Convert the payload to UTF-32LE
    //     const utf32le = Array.from(str, (ch) => {
    //         // Get the code point
    //         const codePoint = ch.codePointAt(0);
    //         // Write it as a 32-bit LE value in the buffer
    //         view.setUint32(0, codePoint, true);
    //         // Read it as individual bytes and create a plain array of them
    //         return Array.from(uint8);
    //     }).flat(); // Flatten the array of arrays into one long byte sequence
    //     // Create the blob and URL
    //     const b = new Blob(
    //         [ BOM, new Uint8Array(utf32le)],
    //         { type: "text/html; charset=UTF-32LE"} // Set the MIME type
    //     );
    //     const url = URL.createObjectURL(b);
    //     return url;
    // }
    


    const onSearchButtonClick = async (WGBC) => {
        console.log('SearchBody-> WGBC:',WGBC)
        console.log(selectedBookGroup);
        console.log(selectedBook);
        console.log(selectedChapter);
        setLoadingShow(true);
        var Type="";

        setResults('');
        setT_results('');

        switch(searchtabIndex){
            case 0: 
                    if (WGBC.BookGroup==='5'){
                        Type="Manavi"//مانوی
                    }else{
                        Type="Pahlavi"//پهلوی
                    }
                    break;
            case 1: Type="Transcription";break;//آوانویسی
            case 2: Type="Transliteration";break;//حرف‌‌‌ نویسی
            case 3: Type="Translation";break;//معنی فارسی
            case 4: Type="WordRoot";break;//بن واژه
            default: break;
        }



        // var str = "äöüÄÖÜçéèñ";
        // var b64 = window.btoa(unescape(encodeURIComponent(str)))
        //console.log(b64);
        // var str2 = decodeURIComponent(escape(window.atob(b64)));
        //console.log(str2);

        //setState({word:WGBC.Word})
        //console.log('Word:',WGBC.Word);
        //console.log('Wordbtoa1:',encodeURI(WGBC.Word));
        //console.log('Wordbtoa2:',encodeURIComponent(WGBC.Word));
        //console.log('Wordbtoa3:',getUTF32LEUrl(WGBC.Word));
        //console.log('Wordbtoa:',btoa(encodeURIComponent(WGBC.Word)));

        //setSelectedBookGroup(WGBC.BookGroup)
        //console.log('sentenceresult/'+Type+'/'+encodeURI(WGBC.Word)+'/'+WGBC.BookGroup+'/'+WGBC.Book+'/'+WGBC.Chapter)

        const responseResult = await webapi.get('sentenceresult/'+Type+'/'+encodeURI(WGBC.Word)+'/'+WGBC.BookGroup+'/'+WGBC.Book+'/'+WGBC.Chapter);
        setResults(responseResult.data);

        //console.log(responseResult.data)

        const responset_Result = await webapi.get('sentencetresult/'+Type+'/'+encodeURI(WGBC.Word)+'/'+WGBC.BookGroup+'/'+WGBC.Book+'/'+WGBC.Chapter);
        setT_results(responset_Result.data);

        //console.log(responset_Result.data)

        setLoadingShow(false)
    };

    const onSearchBoxChanged=()=>{
        setResults('');
        setT_results('');
        setWord('');
    }

    const onSelectTab = (val) => {
        //console.log(val);
        setSearchtabIndex(val)
        setResults('');
        setT_results('');
        setWord('');
    }

 //console.log(1,pageData,2,props.languageInfo)

if (pageData && props.languageInfo) {
    return (
        <div>
            <div className="container-fluid" id="innerpage_row_1">
                <div className="container">
                    <h1 id="page_title">{pageData.length!==0 && pageData[0].F202!== undefined?pageData[0].F202:202/*جستجوی واژه*/}</h1>
                    <h2 id="page_title_dek">{pageData.length!==0 && pageData[0].F20200!== undefined?pageData[0].F20200:20200/*فهرست واژگان و تنوع و بسامد واژه‌های فارسی میانه*/}</h2>
                    <hr className="halfwidth" />
                </div>
            </div>
            <SearchBodySearchBox  
                selectedtabIndex={searchtabIndex} 
                onSelectTab={onSelectTab} 

                onSearchButtonClick={onSearchButtonClick}
                onSearchBoxChanged={onSearchBoxChanged}

                selectedBookGroup = {selectedBookGroup}
                selectedBook = {selectedBook}
                selectedChapter = {selectedChapter}

                setSelectedBookGroup = {setSelectedBookGroup}
                setSelectedBook = {setSelectedBook}
                setSelectedChapter = {setSelectedChapter}

                word={word}
                setWord = {setWord}

                pageData={pageData}
                lang = {props.languageInfo[0].Code}
            />
            {
                (
                    (results && results.length>0)
                )
                ?
                    <SearchBodySearchResult   
                        setStatments={setStatments} 
                        results={results} 
                        t_results={t_results} 
                        word={word}
                        pageData={pageData}
                        searchtabIndex={searchtabIndex}
                        selectedBookGroup={selectedBookGroup}
                    />
                :
                    <EmptyDiv />
            }
            <Loading loadingShow = {loadingShow} />
        </div>
        )
    }
    else
    {
        return (
            <div></div>
        )
    }
}

export default SearchBody;